export { default } from './FlagshipHotel';
